<template>
  <div class="login container">

    <div class="row d-flex justify-content-center">
      
        <img alt="Vue logo" src="../assets/toggle.svg" id="logo">
     
    </div>

    <div class="row d-flex justify-content-center">
      
        <img alt="Vue logo" src="../assets/pos_mode_logo.svg" id="pos_mode_logo_logo">
      
    </div>

    <form @submit.prevent="submit" >

      <div class="row pl-2 pr-2 size-limit m-auto">
          <text-input label="Email address" type="email" v-model="email" placeholder="Enter email address" name="email" v-validate="'required'"/>
        </div>
        
        <div class="row pl-2 pr-2 pt-3 pb-2 size-limit m-auto">
          <text-input label="Password" type="password"  v-model="password" placeholder="Enter password" name="password" v-validate="'required'"/>
        </div>

        <div class="row d-flex justify-content-center pl-2 pr-2 pt-5">
          <cta type="submit" text="Log in" icon="right-arrow" :disabled="submitted" :loading="submitted" />
        </div>

    </form>
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        email:'',
        password:'',
        submitted:false
      };
  },
  created:function(){


     // setInterval(()=>{ this.submitted = this.submitted ? false :true }, 3000);

    
  },
  computed: {
      intendedUrl(){
        return this.$store.getters.getIntendedUrl;
      }
  },
  methods:{

      /*
      * Login form submit handler
      */
      submit()
      {

        this.$validator.validateAll().then((result) => {
          if(result){
            let remember_token = localStorage.getItem('x-remember-token');
            this.submitted = true;
            this.$store.dispatch('login', {
                email           :this.email,
                password        :this.password, 
                remember_token,
                success_callback:this.loginSuccess,
                error_callback  :this.loginError
            });
          }
        });
          
      },

      /*
      * Login error callback
      */
      loginError(result)
      {
          this.submitted = false;
          let error_to_error = {
            email:'email',
            possword:'password'
          }
          this.validateGraphResponse(result,error_to_error);
      },

      /*
      * Login success callback
      */
      loginSuccess(twofactor_enabled,twofactor_disabled)
      {
        if(!this.$store.getters.getUserPermissions.some(p => p.name === 'query-units')) {
          this.submitted = false;
          this.$bus.$emit('error_message', 'You don\'t have permission to access this feature');
        }
        else {
          this.submitted = false;
          if(twofactor_disabled){
            this.$store.commit('SET_TWOFACTOR_JOURNEY_COMPLETE',true);
            return this.$router.push({ name: 'home'});
          }
          if(twofactor_enabled) {
            this.$store.commit('SET_TWOFACTOR_JOURNEY_COMPLETE',false);
            return this.$router.push({ name: 'twofactor'});
          } else {
            this.$store.commit('SET_TWOFACTOR_JOURNEY_COMPLETE',true);
            return this.$router.push({ name: 'home' })
          }
        }
      },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #logo{
    max-width:80px;
    margin-top:50px;

  }

  .input{
    display: block;
    width: 50%;
    min-width:290px;
    margin: 0 auto;
    float: none;
    margin-bottom: 30px;
    overflow: auto;
  }

  #pos_mode_logo_logo{
    max-width:100px;
    margin-top:10px;
    margin-bottom: 60px;
  }

  .cta-container{
    margin-top: 0;
  }

</style>
